var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconfeatherEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.42,
    height: 17.42,
    viewBox: "0 0 17.42 17.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-edit",
    "data-name": "Icon feather-edit",
    transform: "translate(-2.25 -2.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3166",
    "data-name": "Path 3166",
    d: "M10.121,6H4.582A1.582,1.582,0,0,0,3,7.582V18.659a1.582,1.582,0,0,0,1.582,1.582H15.659a1.582,1.582,0,0,0,1.582-1.582V13.121",
    transform: "translate(0 -1.504)",
    fill: "none",
    stroke: "#393939",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3167",
    "data-name": "Path 3167",
    d: "M20.307,3.31a1.678,1.678,0,0,1,2.374,2.374L15.165,13.2,12,13.99l.791-3.165Z",
    transform: "translate(-4.253 0)",
    fill: "none",
    stroke: "#393939",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconfeatherEdit);
export default __webpack_public_path__ + "static/media/Icon feather-edit.dc315cb8ca8ad698b8e5519a2e4aa92d.svg";
export { ForwardRef as ReactComponent };